import { defineComponent as _defineComponent } from 'vue'
import { twMerge } from 'tailwind-merge'

interface SkeletonProps {
  twClass?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Skeleton',
  props: {
    twClass: null
  },
  setup(__props: any) {



return { __sfc: true,twMerge }
}

})